import { useEffect, useState } from "react";

const heroImages = [
  "https://public.readdy.ai/ai/img_res/2a8332f856b1de3db86c330f2363bd34.jpg",
  "https://readdy.ai/api/search-image?query=elegant%20Japanese%20nail%20art%20close%20up%20shot%2C%20creamy%20white%20and%20gold%20leaf%20minimalist%20gel%20nail%20design%20on%20feminine%20hands%2C%20clean%20nude%20beige%20base%20with%20abstract%20gold%20foil%20art%2C%20luxury%20nail%20salon%20photography%2C%20soft%20pastel%20cream%20marble%20background%2C%20artistic%20beauty%20photography%2C%20premium%20nail%20craftsmanship%20close%20up&width=800&height=1050&seq=hero2&orientation=portrait",
];

const previewImages = [
  "https://readdy.ai/api/search-image?query=trendy%20aurora%20ombre%20nail%20art%20on%20elegant%20hands%2C%20iridescent%20holographic%20pastel%20gel%20nails%2C%20clean%20light%20background%2C%20Japanese%20nail%20art%20trend%202026%2C%20beauty%20close%20up%20photography&width=400&height=260&seq=prev_aurora_01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=soft%20warm%20caramel%20beige%20matte%20gel%20nails%20on%20feminine%20hands%2C%20latte%20milk%20tea%20toned%20nail%20polish%20with%20smooth%20velvety%20finish%2C%20delicate%20gold%20foil%20stripe%20accent%2C%20clean%20white%20ivory%20background%2C%20professional%20nail%20salon%20photography%2C%20bright%20well%20lit%20studio%20shot&width=300&height=300&seq=prev_milktea_01&orientation=squarish",
  "https://readdy.ai/api/search-image?query=elegant%20white%20marble%20swirl%20gel%20nails%20with%20gold%20leaf%20vein%20details%20on%20feminine%20hands%2C%20luxury%20high%20end%20nail%20art%2C%20pristine%20cream%20white%20background%2C%20professional%20close%20up%20beauty%20photography%2C%20bright%20natural%20studio%20lighting&width=300&height=300&seq=prev_marble_01&orientation=squarish",
];

export default function HeroSection() {
  const [currentImg, setCurrentImg] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
    const timer = setInterval(() => {
      setCurrentImg((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen bg-[#FAFAF8] pt-16 lg:pt-20 overflow-hidden"
    >
      {/* Background decorative circle */}
      <div className="absolute top-[-100px] right-[-100px] w-[500px] h-[500px] rounded-full bg-[#F0E8DF]/50 pointer-events-none"></div>
      <div className="absolute bottom-[-80px] left-[-60px] w-[300px] h-[300px] rounded-full bg-[#F5EDE3]/40 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 lg:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-6 min-h-[85vh]">

          {/* Left — Text Content */}
          <div
            className={`flex-1 lg:max-w-[38%] transition-all duration-1000 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <p className="font-['DM_Sans'] text-xs font-medium tracking-[0.3em] uppercase text-[#C9A87C] mb-6">
              Tokyo Nail Atelier — 2026 Collection
            </p>
            <h1 className="font-['Cormorant_Garamond'] text-[4rem] lg:text-[5.5rem] font-light leading-[0.9] text-[#1A1A1A] mb-8">
              <span className="block">トレンドを</span>
              <span className="block italic text-[#C9A87C]">纏う指先</span>
              <span className="block">アート</span>
            </h1>
            <p className="font-['Noto_Sans_JP'] text-sm text-[#6B6B6B] leading-relaxed mb-10 max-w-sm">
              季節ごとに進化するトレンドデザインを取り入れた<br />
              プレミアムネイルアートサロン。丁寧なカウンセリングから<br />
              あなただけの唯一無二の指先へ。
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => handleScroll("#gallery")}
                className="flex items-center gap-2 bg-[#3D2E2A] text-white text-sm font-medium px-8 py-3.5 rounded-full hover:bg-[#C9A87C] transition-colors duration-300 cursor-pointer whitespace-nowrap font-['DM_Sans'] tracking-wider"
              >
                ギャラリーを見る
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => handleScroll("#booking")}
                className="flex items-center gap-2 border border-[#3D2E2A] text-[#3D2E2A] text-sm font-medium px-8 py-3.5 rounded-full hover:bg-[#3D2E2A] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap font-['DM_Sans'] tracking-wider"
              >
                <i className="ri-calendar-line"></i>
                ご予約はこちら
              </button>
            </div>

            {/* Stats */}
            <div className="flex items-center gap-10 mt-14 pt-8 border-t border-[#E8E4DF]">
              <div>
                <p className="font-['Cormorant_Garamond'] text-3xl font-semibold text-[#1A1A1A]">500+</p>
                <p className="font-['Noto_Sans_JP'] text-xs text-[#9E9189] mt-1">施術デザイン</p>
              </div>
              <div className="w-px h-10 bg-[#E8E4DF]"></div>
              <div>
                <p className="font-['Cormorant_Garamond'] text-3xl font-semibold text-[#1A1A1A]">4.9</p>
                <p className="font-['Noto_Sans_JP'] text-xs text-[#9E9189] mt-1">顧客満足度</p>
              </div>
              <div className="w-px h-10 bg-[#E8E4DF]"></div>
              <div>
                <p className="font-['Cormorant_Garamond'] text-3xl font-semibold text-[#1A1A1A]">8年</p>
                <p className="font-['Noto_Sans_JP'] text-xs text-[#9E9189] mt-1">サロン営業</p>
              </div>
            </div>
          </div>

          {/* Center — Hero Image */}
          <div
            className={`flex-shrink-0 relative transition-all duration-1000 delay-200 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <div className="relative w-[300px] lg:w-[340px] h-[420px] lg:h-[500px] rounded-[28px] overflow-hidden">
              {heroImages.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`ネイルアート${i + 1}`}
                  className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-1000 ${
                    i === currentImg ? "opacity-100" : "opacity-0"
                  }`}
                />
              ))}
              {/* Floating badge */}
              <div className="absolute bottom-5 left-5 bg-white/90 backdrop-blur-sm px-4 py-2.5 rounded-full">
                <p className="font-['DM_Sans'] text-xs font-medium text-[#3D2E2A] tracking-wider">
                  2026 Spring Collection
                </p>
              </div>
            </div>
            {/* Dot indicators */}
            <div className="flex justify-center gap-2 mt-4">
              {heroImages.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentImg(i)}
                  className={`rounded-full transition-all duration-300 cursor-pointer ${
                    i === currentImg ? "w-6 h-2 bg-[#C9A87C]" : "w-2 h-2 bg-[#D8D2CB]"
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Right — Preview Mini Gallery */}
          <div
            className={`hidden lg:flex flex-col gap-3 flex-1 max-w-[26%] transition-all duration-1000 delay-300 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <div className="flex items-center justify-between mb-1">
              <p className="font-['DM_Sans'] text-xs font-semibold tracking-[0.2em] uppercase text-[#1A1A1A]">
                人気デザイン
              </p>
              <button
                onClick={() => handleScroll("#gallery")}
                className="w-7 h-7 flex items-center justify-center cursor-pointer"
              >
                <i className="ri-arrow-right-up-line text-sm text-[#C9A87C]"></i>
              </button>
            </div>
            {/* Top wide image */}
            <div className="relative rounded-[16px] overflow-hidden h-[140px] w-full">
              <img
                src={previewImages[0]}
                alt="オーロラネイル"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-2 left-2 bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full">
                <p className="font-['Noto_Sans_JP'] text-[10px] text-[#3D2E2A]">オーロラ</p>
              </div>
            </div>
            {/* Bottom two images */}
            <div className="flex gap-3">
              <div className="relative flex-1 rounded-[16px] overflow-hidden h-[120px]">
                <img
                  src={previewImages[1]}
                  alt="ミルクティーネイル"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute bottom-2 left-2 bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full">
                  <p className="font-['Noto_Sans_JP'] text-[10px] text-[#3D2E2A]">ミルクティー</p>
                </div>
              </div>
              <div className="relative flex-1 rounded-[16px] overflow-hidden h-[120px]">
                <img
                  src={previewImages[2]}
                  alt="ゴールドマーブルネイル"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute bottom-2 left-2 bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full">
                  <p className="font-['Noto_Sans_JP'] text-[10px] text-[#3D2E2A]">マーブル</p>
                </div>
              </div>
            </div>

            {/* CTA mini card */}
            <div className="bg-[#3D2E2A] rounded-[16px] p-5 mt-1">
              <p className="font-['Cormorant_Garamond'] text-white text-lg font-medium leading-tight mb-3">
                無料カウンセリング<br />受付中
              </p>
              <button
                onClick={() => handleScroll("#booking")}
                className="w-full bg-[#C9A87C] text-white text-xs font-medium py-2.5 rounded-full hover:bg-white hover:text-[#3D2E2A] transition-colors duration-300 cursor-pointer font-['DM_Sans'] tracking-wider whitespace-nowrap"
              >
                今すぐ予約
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
